"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Component = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _innerComponent = _interopRequireDefault(require("./inner-component"));

var _compiler = _interopRequireDefault(require("mson/lib/compiler"));

var _attach = _interopRequireDefault(require("./attach"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Component = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Component, _React$PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    (0, _classCallCheck2.default)(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      component: null
    });
    return _this;
  }

  (0, _createClass2.default)(Component, [{
    key: "createComponent",
    value: function createComponent() {
      var definition = this.props.definition;
      this.setState({
        component: _compiler.default.newComponent(definition)
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.definition) {
        this.createComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var component = this.state.component; // Did we use a definition to define a component in the state?

      if (component) {
        // Fire the unmount before we destroy the component so that the event is not lost
        component.emitChange('unmount'); // Remove all listeners to prevent listener leaks

        this.state.component.destroy();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Is the definition changing?
      if (this.props.definition !== prevProps.definition) {
        this.createComponent();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          definition = _this$props.definition,
          component = _this$props.component,
          childProps = (0, _objectWithoutProperties2.default)(_this$props, ["definition", "component"]);
      var comp = component; // Should we use the component generated from the definition?

      if (!component) {
        comp = this.state.component;
      } // Note: the component can be falsy, e.g. it has not yet been defined


      if (comp && comp.get('hidden')) {
        return null;
      } else {
        return /*#__PURE__*/_react.default.createElement(_innerComponent.default, (0, _extends2.default)({
          component: comp
        }, childProps));
      }
    }
  }]);
  return Component;
}(_react.default.PureComponent);

exports.Component = Component;

var _default = (0, _attach.default)(['hidden'])(Component);

exports.default = _default;